<div class="sidenav-content" cdkScrollable>
	<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()" [titleHeaderText]="'issue.select.first.batch'|translate">
		<div class="invoiced-only-filter">
			<copo-slide-button
				class="justify-center"
				labelAfter="filter.all"
				labelBefore="issue.invoiced.batch"
				[checked]="togglePos"
				(toggleChange)="settogglePos($event)">
			</copo-slide-button>
		</div>
		<mat-form-field class="quick-search" appearance="outline" subscriptSizing="dynamic">
			<input [placeholder]="'issue.batch.quick.search'|translate" matInput type="text" spellcheck="false"
				autocomplete="off" [formControl]="searchTextControl" />
			<button type="button" *ngIf="searchTextControl.value" mat-icon-button (click)="searchTextControl.reset('');"
				tabindex="-1" matSuffix>
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
			<mat-icon svgIcon="search" class="quick-search-icon" *ngIf="!searchTextControl.value" matSuffix></mat-icon>
		</mat-form-field>
			<button mat-flat-button
					type="submit"
					[disabled]="selectedBatch === undefined && mainClaimBatch === undefined"
					color="primary"
					*ngIf="viewDeclareMenu"
					class="button-next"
					(click)="setMainBatchOnClaim()">
				<span translate>issue.select.batches.action.next</span>
			</button>
	</copo-panel-header>
	<!-- keep a div to keep step sizing aligned between screens -->
	<div class="copo-stepper-container">
		<copo-stepper [steps]="steps"></copo-stepper>
	</div>
	<div class="copo-container" copoVirtualScroller [dataId]="dataId" #scroller="copoVirtualScroller"
		(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)">
		<ng-container *ngIf="mainClaimBatch !== undefined" class="selected-batch-box">
			<div class="select-batch">
				<span class="select-batch-text" translate>issue.select.current.batch</span>
			</div>
			<div class="batch-card-container" role="group" aria-labelledby="seleted-batch-ref seleted-batch-qty">
				<mat-radio-button
					name="select-batch-radio" class="batch-card-container-icon radio-btn-align"
					aria-labelledby="seleted-batch-ref seleted-batch-qty"
					[checked]="true" (change)="selectBatch(mainClaimBatch, $event);"></mat-radio-button>
				<div class="batch-card-border card-portal grid-container">
					<mat-icon class="batch-icon-color" svgIcon="icon-batch"></mat-icon>
					<div class="card-container-column" id="seleted-batch-ref">
						<span class="card-content-label-column" translate>issue.batch.number</span>
						<span>{{ mainClaimBatch.batchReference ? mainClaimBatch.batchReference : UNDERSCORE }}</span>
					</div>
					<div class="card-column">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.customer.order.number</span>
							<span>{{ mainClaimBatch.customerOrderNumber ? mainClaimBatch.customerOrderNumber : UNDERSCORE
								}}</span>
						</div>
						<div class="card-container-row">
							<mat-icon class="batch-mill-icon" svgIcon="at_consignment"></mat-icon>
							<span>{{ mainClaimBatch.millDescription }}</span>
						</div>
					</div>
					<div class="card-column">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.steelgrade</span>
							<span>{{ mainClaimBatch.steelgradeDescription ? mainClaimBatch.steelgradeDescription : UNDERSCORE
								}}</span>
						</div>
						<a mat-button color="primary" class="card-container-documents"
							[routerLink]="['/order-tracking/batch/card', mainClaimBatch.id]" fragment="documents">
							<span class="card-container-documents-span" translate>issue.batch.commercial.documents</span>
							<mat-icon iconPositionEnd color="accent" svgIcon="table_document"></mat-icon>
						</a>
					</div>
					<div class="card-column">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.dimension</span>
							<span>{{ mainClaimBatch | copoDimension }}</span>
						</div>
						<div class="card-container-column">
							<span class="card-content-label-column invoice-date-label" translate>batch.invoice.date</span>
							<span>{{ mainClaimBatch.invoiceDate }}</span>
						</div>
					</div>
					<div class="card-column">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.cdd</span>
							<span>{{ mainClaimBatch.cddWeek ? mainClaimBatch.cddWeek : UNDERSCORE }}</span>
						</div>
						<div *ngIf="mainClaimBatch.batchInvoiced === 'X'" class="container-invoiced-value">
							<mat-icon color="accent" class="batch-invoiced-icon" svgIcon="invoice"></mat-icon>
							<span translate>issue.batch.invoiced</span>
						</div>
					</div>
					<div class="card-column card-column-center">
						<div class="card-container-column">
							<span class="batch-quantity-pill" id="seleted-batch-qty">{{ getBatchQuantity(mainClaimBatch) | copoNumber:'weight':'t'
								}}</span>
						</div>
						<div class="card-container-row container-view-details">
							<a mat-button color="primary" [routerLink]="['/order-tracking/batch/card', mainClaimBatch.id]">
								<span class="view-details-label" translate>issue.batch.view-details</span>
								<mat-icon color="accent" svgIcon="md:chevron_right" iconPositionEnd></mat-icon>
							</a>
						</div>
					</div>
				</div>
				<div class="card-mobile card-block">
					<div class="card-row">
						<div class="card-container-column">
							<div class="card-container-row batch-icon-container">
								<mat-icon class="batch-icon-color" svgIcon="in_stock"></mat-icon>
							</div>
						</div>
						<span class="batch-quantity-pill">{{ getBatchQuantity(mainClaimBatch) | copoNumber:'weight':'t' }}</span>
					</div>
					<div class="card-row" *ngIf="selectedBatch !== undefined">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.number</span>
							<span class="overflow-wrap">{{ selectedBatch.batchReference }}</span>
						</div>
					</div>
					<div class="card-row">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.customer.order.number</span>
							<span class="overflow-wrap">{{ mainClaimBatch.customerOrderNumber ? mainClaimBatch.customerOrderNumber
								: UNDERSCORE }}</span>
						</div>
						<div class="card-container-row">
							<mat-icon class="row-icon" svgIcon="at_consignment"></mat-icon>
							<span class="overflow-wrap">{{ mainClaimBatch.millDescription }}</span>
						</div>
					</div>
					<div class="card-row">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.steelgrade</span>
							<span class="overflow-wrap">{{ mainClaimBatch.steelgradeDescription ?
								mainClaimBatch.steelgradeDescription : UNDERSCORE
								}}</span>
						</div>
						<a mat-button color="primary" class="card-container-documents"
							[routerLink]="['/order-tracking/batch/card', mainClaimBatch.id]" fragment="documents">
							<span class="card-container-documents-span" translate>issue.batch.commercial.documents</span>
							<mat-icon iconPositionEnd color="accent" svgIcon="table_document"></mat-icon>
						</a>
					</div>
					<div class="card-row">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.dimension</span>
							<span>{{ mainClaimBatch | copoDimension }}</span>
						</div>
						<div class="container-label-value">
							<span class="card-content-label-column invoice-date-label" translate>batch.invoice.date</span>
							<span class="batch-invoice-font card-content-label-row">{{ mainClaimBatch.invoiceDate }}</span>
						</div>
					</div>
					<div class="card-row">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.cdd</span>
							<span>{{ mainClaimBatch.cddWeek ? mainClaimBatch.cddWeek : UNDERSCORE }}</span>
						</div>
						<div class="card-container-row container-view-details">
							<a mat-button color="primary" [routerLink]="['/order-tracking/batch/card', mainClaimBatch.id]">
								<span class="view-details-label" translate>issue.batch.view-details</span>
								<mat-icon color="accent" svgIcon="md:chevron_right" iconPositionEnd></mat-icon>
							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="select-batch">
				<span class="select-batch-text" translate>issue.select.other.batch</span>
			</div>
		</ng-container>
		<ng-container *ngIf="!loading">
			<div *ngFor="let batch of scroller.list; let i = index" class="batch-card-container" role="group" [attr.aria-labelledby]="'batch-ref-' + i + ' batch-qty-' + i">
				<mat-radio-button
					name="select-batch-radio"
					class="batch-card-container-icon radio-btn-align"
					[aria-labelledby]="'batch-ref-' + i + ' batch-qty-' + i"
					(change)="selectBatch(batch, $event);"></mat-radio-button>
				<div class="batch-card-container-items card-portal grid-column-one-full grid-container">
					<div class="card-column">
						<div class="card-container-row batch-icon-container">
							<mat-icon class="batch-icon-color" svgIcon="icon-batch"></mat-icon>
						</div>
					</div>
					<div class="card-column">
						<div class="card-container-column" [attr.id]="'batch-ref-' + i">
							<span class="card-content-label-column" translate>issue.batch.number</span>
							<span>{{ batch.batchReference ? batch.batchReference : UNDERSCORE }}</span>
						</div>
					</div>
					<div class="card-column">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.customer.order.number</span>
							<span>{{ batch.customerOrderNumber ? batch.customerOrderNumber : UNDERSCORE }}</span>
						</div>
						<div class="card-container-row">
							<mat-icon class="batch-mill-icon" svgIcon="at_consignment"></mat-icon>
							<span>{{ batch.millDescription }}</span>
						</div>
					</div>
					<div class="card-column">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.steelgrade</span>
							<span>{{ batch.steelgradeDescription ? batch.steelgradeDescription : UNDERSCORE }}</span>
						</div>
						<a mat-button color="primary" class="card-container-documents"
							[routerLink]="['/order-tracking/batch/card', batch.id]" fragment="documents">
							<span class="card-container-documents-span" translate>issue.batch.commercial.documents</span>
							<mat-icon iconPositionEnd color="accent" svgIcon="table_document"></mat-icon>
						</a>
					</div>
					<div class="card-column">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.dimension</span>
							<span>{{ batch | copoDimension }}</span>
						</div>
						<div class="container-label-value">
							<span class="card-content-label-column invoice-date-label" translate>batch.invoice.date</span>
							<span class="batch-invoice-font card-content-label-row">{{ batch.invoiceDate }}</span>
						</div>
					</div>
					<div class="card-column">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.cdd</span>
							<span>{{ batch.cddWeek ? batch.cddWeek : UNDERSCORE }}</span>
						</div>
						<div *ngIf="batch.batchInvoiced === 'X'" class="container-invoiced-value">
							<mat-icon color="accent" class="batch-invoiced-icon" svgIcon="invoice"></mat-icon>
							<span translate>issue.batch.invoiced</span>
						</div>
					</div>
					<div class="card-column card-column-center">
						<div class="card-container-column">
							<span class="batch-quantity-pill" [attr.id]="'batch-qty-' + i">{{ getBatchQuantity(batch) | copoNumber:'weight':'t' }}</span>
						</div>
						<div class="card-container-row container-view-details">
							<a mat-button color="primary" [routerLink]="['/order-tracking/batch/card', batch.id]">
								<span class="view-details-label" translate>issue.batch.view-details</span>
								<mat-icon color="accent" svgIcon="md:chevron_right" iconPositionEnd></mat-icon>
							</a>
						</div>
					</div>
				</div>
				<div class="card-mobile grid-column-one-full card-block">
					<div class="card-row">
						<div class="card-container-column">
							<div class="card-container-row batch-icon-container">
								<mat-icon class="batch-icon-color" svgIcon="in_stock"></mat-icon>
							</div>
						</div>
						<span class="batch-quantity-pill">{{ getBatchQuantity(batch) | copoNumber:'weight':'t' }}</span>
					</div>
					<div class="card-row">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.number</span>
							<span class="overflow-wrap">{{ batch.batchReference }}</span>
						</div>
					</div>
					<div class="card-row">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.customer.order.number</span>
							<span class="overflow-wrap">{{ batch.customerOrderNumber ? batch.customerOrderNumber : UNDERSCORE }}</span>
						</div>
						<div class="card-container-row">
							<mat-icon class="row-icon" svgIcon="at_consignment"></mat-icon>
							<span class="overflow-wrap">{{ batch.millDescription }}</span>
						</div>
					</div>
					<div class="card-row">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.steelgrade</span>
							<span class="overflow-wrap">{{ batch.steelgradeDescription ? batch.steelgradeDescription : UNDERSCORE
								}}</span>
						</div>
						<a mat-button color="primary" class="card-container-documents"
							[routerLink]="['/order-tracking/batch/card', batch.id]" fragment="documents">
							<span class="card-container-documents-span" translate>issue.batch.commercial.documents</span>
							<mat-icon iconPositionEnd color="accent" svgIcon="table_document"></mat-icon>
						</a>
					</div>
					<div class="card-row">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.dimension</span>
							<span>{{ batch | copoDimension }}</span>
						</div>
						<div class="container-label-value">
							<span class="card-content-label-column invoice-date-label" translate>batch.invoice.date</span>
							<span class="batch-invoice-font card-content-label-row">{{ batch.invoiceDate }}</span>
						</div>
					</div>
					<div class="card-row">
						<div class="card-container-column">
							<span class="card-content-label-column" translate>issue.batch.cdd</span>
							<span>{{ batch.cddWeek ? batch.cddWeek : UNDERSCORE }}</span>
						</div>
						<div class="card-container-row container-view-details">
							<a mat-button color="primary" [routerLink]="['/order-tracking/batch/card', batch.id]">
								<span class="view-details-label" translate>issue.batch.view-details</span>
								<mat-icon color="accent" svgIcon="md:chevron_right" iconPositionEnd></mat-icon>
							</a>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
		<copo-loading-spinner *ngIf="scroller.loading || loading"></copo-loading-spinner>
		<div translate class="empty-page-text" *ngIf="!(scroller.loading || loading) && scroller.list.length === 0">
			issue.batch.no.result
		</div>
	</div>
</div>
